import { render } from "./QuickHistoryList.vue?vue&type=template&id=6bbab9de&scoped=true&ts=true"
import script from "./QuickHistoryList.vue?vue&type=script&lang=ts"
export * from "./QuickHistoryList.vue?vue&type=script&lang=ts"

import "./QuickHistoryList.vue?vue&type=style&index=0&id=6bbab9de&lang=css"
import "./QuickHistoryList.vue?vue&type=style&index=1&id=6bbab9de&scoped=true&lang=css"

import exportComponent from "/var/www/mj-root/fe-site-manager/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bbab9de"]])

export default __exports__